export enum EntryPointCodeEnum {
	V1 = 8002,
	V2 = 10001,
}
